// extracted by mini-css-extract-plugin
module.exports = {"competitorIcon":"style_competitorIcon__77Of4","pageTitleUrl":"style_pageTitleUrl__l8xBO","selectInput":"style_selectInput__bKQhM","tableOuterPages":"style_tableOuterPages__AgusG"};